import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

type StickyObject = {
	key: string;
	sortPriority: number;
	stickyObject: React.ReactElement;
	height: number;
	isHidden: boolean;
};

export type TopStickySectionContextProps = {
	stickyChildren: StickyObject[];
	setStickyChildren: React.Dispatch<React.SetStateAction<StickyObject[]>>;
	setHeightStickySection: (heightStickySection: number) => void;
};

const TopStickySectionContext = React.createContext<
	TopStickySectionContextProps | undefined
>(undefined);

export const TopStickySectionContextProvider: React.FC<{
	setHeightStickySection: (heightStickySection: number) => void;
	children: React.ReactNode;
}> = ({setHeightStickySection, children}) => {
	const [stickyChildren, setStickyChildren] = React.useState<StickyObject[]>(
		[],
	);
	const location = useLocation();
	useEffect(() => {
		setStickyChildren([]);
	}, [location.pathname]);
	return (
		<TopStickySectionContext.Provider
			value={{
				stickyChildren,
				setStickyChildren,
				setHeightStickySection,
			}}
		>
			{children}
		</TopStickySectionContext.Provider>
	);
};

export const useTopStickySectionContext = () =>
	React.useContext(TopStickySectionContext) as TopStickySectionContextProps;
